import { DensityMediumRounded } from '@mui/icons-material';
import { Typography } from '@mui/material';
import styled from 'styled-components';

const List = styled.div`
  background-color: ${({ theme }) => theme.palette.background.default};
`;

interface ListItemProps {
  index: number
}

const ListItem = styled.div<ListItemProps>`
  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  outline: 1px solid;
  outline-color: ${({ theme }) => theme.palette.divider};
  margin-top: 1px;
  color: ${({ theme }) => theme.palette.backdrop.contrastText};
  padding: ${({ theme }) => theme.spacing(2)};
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
`;

interface Highlightable {
  highlight?: string
}

const Icon = styled(DensityMediumRounded)<Highlightable>`
  && {
    height: 12px;
    color: ${({ highlight, theme }) => (highlight === 'true' ? theme.palette.highlight.main : 'inherit')}
  }
`;

const IconContainer = styled.div`
  padding-right: ${({ theme }) => theme.spacing(1)};
`;

const ListItemText = styled(Typography)<Highlightable>`
  && {
    color: ${({ highlight, theme }) => (highlight === 'true' ? theme.palette.highlight.main : 'inherit')}
  }
`;

export { List, ListItem, Icon, IconContainer, ListItemText };
